import React from 'react';
import { List, ListItem } from 'material-ui/List';
import { Route, Switch } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import _ from 'lodash';
import Translate from 'translate';

import AutomaticMessages from './automatic-messages/';
import PredefinedAnswers from './predefined-answers/';
import AuthService from 'services/AuthService';
import Categories from './categories/';
import Services from './services/';
import Emails from './emails/';
import Facebook from './facebook/';
import SMS from './sms/';
import PhoneSms from './phone';
import Twitter from './twitter/';
import UserGroups from './user-groups/';
import Users from './users/';
import Tones from './tones/';
import Settings from './settings/';
import NetworkLimit from './networkLimit/';
import Chat from './chat/';
import { toggleLoading } from "stores/actions";
import { connect } from "react-redux";

class Configuration extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      activeTab: 0,
      data: [],
    };

    this.socialNetworks = props.chatActive ? [
      { icon: 'facebook-f', name: 'Facebook', route: '/configurations/facebook' },
      { icon: 'twitter', name: 'Twitter', route: '/configurations/twitter' },
      { icon: 'envelope-o', name: <Translate id="email"/>, route: '/configurations/email' },
      { icon: 'comments', name: <Translate id="chat"/>, route: '/configurations/chat-config' },
    ] : [
      { icon: 'facebook-f', name: 'Facebook', route: '/configurations/facebook' },
      { icon: 'twitter', name: 'Twitter', route: '/configurations/twitter' },
      { icon: 'envelope-o', name: <Translate id="email"/>, route: '/configurations/email' },
    ];
    if (props.phoneActive){
      this.socialNetworks.push(
        { icon: 'commenting-o', name: <Translate id="sms"/>, route: '/configurations/phone' }
      )
    }
    this.userManagment = [
      { icon: 'user-o', name: <Translate id="users"/>, route: '/configurations/users' },
      { icon: 'users', name: <Translate id="userGroups"/>, route: '/configurations/user-groups' },
      { icon: 'list', name: <Translate id="categories"/>, route: '/configurations/categories' },
      { icon: 'hand-o-right', name: <Translate id="tones"/>, route: '/configurations/tones' },
      { icon: 'server', name: <Translate id="services"/>, route: '/configurations/services' },
    ];
  }

  getActiveTabStyle( url ) {
    return this.props.location.pathname.indexOf( url ) !== -1 ? { backgroundColor: 'rgba(153,153,153,0.4)' } : {}
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="row mt-5">

          <div className="col-md-3">
          {( AuthService.getUserRole().isSupervisor || AuthService.getUserRole().isTechAdmin || AuthService.getUserRole().isAdmin ) &&
              <section className="box box-default">
                <div className="box-header"><Translate id="socialNetworks"/></div>
                <div className="box-body py-0">
                  <List>
                    {_.map( this.socialNetworks, ( network, index ) =>
                      <ListItem key={index}
                                primaryText={network.name}
                                leftIcon={<i className={`fa text-center fa-${network.icon}`} style={{ fontSize: 20 }}/>}
                                onClick={() => this.props.history.push( network.route )}
                                style={this.getActiveTabStyle( network.route )}
                      />
                    )}
                    <Divider/>
                    <ListItem primaryText={<Translate id="charactersLimit"/>}
                              leftIcon={<i className="fa fa-bookmark-o text-center" style={{ fontSize: 20 }}/>}
                              onClick={() => this.props.history.push( '/configurations/characters-limit' )}
                              style={this.getActiveTabStyle( '/configurations/characters-limit' )}
                    />
                  </List>
                </div>
              </section> 
          }
          {( AuthService.getUserRole().isSupervisor || AuthService.getUserRole().isFunctAdmin || AuthService.getUserRole().isAdmin ) &&
            <section className="box box-default">
              <div className="box-header"><Translate id="userManagement"/></div>
              <div className="box-body py-0">
                <List className="p-0">
                  {_.map( this.userManagment, ( item, index ) =>
                    <ListItem key={index}
                              primaryText={item.name}
                              leftIcon={<i className={`fa text-center fa-${item.icon}`} style={{ fontSize: 20 }}/>}
                              onClick={() => this.props.history.push( item.route )}
                              style={this.getActiveTabStyle( item.route )}
                    />
                  )}
                  <Divider/>
                </List>
              </div>

              <div className="box-body py-0">
                <List className="p-0">
                  <ListItem primaryText={<Translate id="predefinedAnswers"/>}
                            leftIcon={<i className="fa fa-commenting text-center" style={{ fontSize: 20 }}/>}
                            onClick={() => this.props.history.push( '/configurations/predefined-answers' )}
                            style={this.getActiveTabStyle( '/configurations/predefined-answers' )}
                  />
                  <ListItem primaryText={<Translate id="automaticMessages"/>}
                            leftIcon={<i className="fa fa-bullhorn text-center" style={{ fontSize: 20 }}/>}
                            onClick={() => this.props.history.push( '/configurations/automatic-messages' )}
                            style={this.getActiveTabStyle( '/configurations/automatic-messages' )}
                  />
                  <Divider className="m-0"/>
                </List>
              </div>

              <div className="box-body py-0">
                <List className="pt-0">
                  <ListItem primaryText={<Translate id="externalCodes"/>}
                            leftIcon={<i className="fa fa-cogs text-center" style={{ fontSize: 20 }}/>}
                            onClick={() => this.props.history.push( '/configurations/settings' )}
                            style={this.getActiveTabStyle( '/configurations/settings' )}
                  />
                </List>
              </div>
            </section>
          }
          </div>

          <div className="col-md-9">
            <Switch>
              <Route path={`${this.props.match.path}/facebook`} component={Facebook}/>
              <Route path={`${this.props.match.path}/twitter`} component={Twitter}/>
              <Route path={`${this.props.match.path}/email`} component={Emails}/>
              <Route path={`${this.props.match.path}/phone`} component={PhoneSms}/>
              <Route path={`${this.props.match.path}/users`} component={Users}/>
              <Route path={`${this.props.match.path}/user-groups`} component={UserGroups}/>
              <Route path={`${this.props.match.path}/categories`} component={Categories}/>
              <Route path={`${this.props.match.path}/services`} component={Services}/>
              <Route path={`${this.props.match.path}/predefined-answers`} component={PredefinedAnswers}/>
              <Route path={`${this.props.match.path}/automatic-messages`} component={AutomaticMessages}/>
              <Route path={`${this.props.match.path}/tones`} component={Tones}/>
              <Route path={`${this.props.match.path}/settings`} component={Settings}/>
              <Route path={`${this.props.match.path}/characters-limit`} component={NetworkLimit}/>
              {!!this.props.chatActive && <Route path={`${this.props.match.path}/chat-config`} component={Chat}/>}
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  phoneActive: state.settings.phoneActive,
  chatActive: state.settings.chatActive,
} );

module.exports = connect(
  mapStateToProps,
  null
)( Configuration );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/index.js